module.exports = __webpack_public_path__ + "img/vitor.40177bc4.png";